export default {
	APPROVED: 'Approved',
	REJECTED: 'Rejected',
}
